<template>
    <client-page>
        <template v-slot:subHead>
            <sub-visual sh="Product" tabActive="Comfortable & Cozy Line" bg="/images/sub/visual/sv-product.jpg" />
        </template>

        <sub-section class="page-section--first page-section--last">
            <sub-product tit="Comfortable & Cozy Line" file="comfortable">
                Single, Towel Terry, Fleece, Texture etc, Variety structure with brush effect. From home to outside, Our soft knit line gives you comfort & cozy feeling you need.
            </sub-product>
        </sub-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import SubSection from "@/components/client/sub/sub-section.vue";
import SubProduct from "@/components/client/sub/sub-product.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubSection,
        SubProduct,
    },
};
</script>

<style lang="scss" scoped></style>
